import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router";
import { ContactUpdateInquiryDetails } from "../contactUpdateInquiries/details/ContactUpdateInquiryDetails";
import { ContactUpdateInquiryList } from "./ContactUpdateInquiryList";

export const ContactUpdateInquiryPage: FC = () => {
	return (
		<Routes>
			<Route index element={<ContactUpdateInquiryList />} />
			<Route path=":contactUpdateInquiryId/*">
				<Route index element={<Navigate to="open-inquiries" replace />} />
				<Route path="*" element={<ContactUpdateInquiryDetails />} />
			</Route>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
